/* eslint-disable react/jsx-key */
// Station
import React, { useState, useMemo, useContext } from 'react'
import { dateCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getPnodeZoneEffective,
} from 'core'
import { connect } from 'react-redux'
import { kindleMySqlGetDALmp, kindleMySqlSaveDALmp } from 'api/pgads.js'
import CommonScreen from 'admin/component/CommonScreen'
import { Button, DatePicker, Select } from 'antd'
import * as R from 'ramda'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits, isValidYearRange } from 'core/utils'

import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import { CriteriaRow } from 'core/screen-util'
import { saveDataMessage } from 'kindle'

const headers = [
  strCol({
    ident: 'nodeId',
    display: 'PNode Id',
    isKey: true,
    width: 200,
    sortOrder: 'asc',
  }),
  dateCol({
    ident: 'deliveryDate',
    display: 'Delivery Date',
    isFiltered: true,
    isRequired: true,
    width: 150,
    isEditable: false,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'hourEnding',
    display: 'Hour Ending',
    isFiltered: true,
    isEditable: false,
  }),

  numCol({
    ident: 'totalLmp',
    display: 'Total Lmp',
    isFiltered: true,
    isEditable: false,
    width: 200,
    displayFormat: '0.0000',
  }),
]

const KindleLmpDa = ({
  title = 'DA LMP',
  apiTargetInfo,
  pnodeZoneList = [],
  ...props
}) => {
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )

  const { setError } = useContext(ErrorContext)
  const { spinning, setSpinning } = useContext(SpinContext)

  const { authGodMode } = props.envConfig

  const actionPermits = props.actionPermits

  const kindleMySqlDALmpWritePermisiion = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.KINDLE_MYSQL_DA_LMP_ADMIN],
        matchAny: true,
      }),
    [actionPermits, authGodMode]
  )

  const distinctPnodeId = useMemo(
    _ =>
      R.compose(
        R.sort((a, b) =>
          (a || '').toLowerCase().localeCompare((b || '').toLowerCase())
        ),
        R.uniq,
        R.map(p => p.pnodeid)
      )(pnodeZoneList || []),
    [pnodeZoneList]
  )
  const [selPNodes, setSelPNodes] = useState(['all'])

  const withCriteria = () => {
    return {
      start: selectedDateRangePicker[0],
      end: selectedDateRangePicker[1],
      pnodes:
        selPNodes.length <= 0 || selPNodes.includes('all')
          ? distinctPnodeId
          : selPNodes,
    }
  }

  const saveData = _ => {
    setSpinning(true)
    kindleMySqlSaveDALmp(apiTargetInfo)({
      start: selectedDateRangePicker[0],
      end: selectedDateRangePicker[1],
      pnodes:
        selPNodes.length <= 0 || selPNodes.includes('all')
          ? distinctPnodeId
          : selPNodes,
    }).fork(setError, _ => {
      setSpinning(false)

      saveDataMessage()
    })
  }

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
          // retrieve({ dates: d })
        }}
      />
    )
  }
  const extraCriteria = ({ onCriteriaChnage }) => {
    return (
      <CriteriaRow
        style={{
          display: 'grid',
          gridTemplateColumns: '100px auto',
          paddingTop: '0px',
        }}
      >
        <div>PNode :</div>
        <Select
          allowClear
          mode="multiple"
          style={{ display: 'grid' }}
          placeholder="Select PNode(s)"
          onChange={values => {
            setSelPNodes(values)
            onCriteriaChnage()
          }}
          value={selPNodes}
        >
          <Select.Option key="all" value="all">
            All
          </Select.Option>
          {(distinctPnodeId || []).map(p => (
            <Select.Option key={p} value={p}>
              {p}
            </Select.Option>
          ))}
        </Select>
      </CriteriaRow>
    )
  }
  const extraCriteriaAfterButton = _ => {
    if (kindleMySqlDALmpWritePermisiion)
      return (
        <Button type="danger" onClick={saveData} loading={spinning} icon="save">
          Save Remote Data
        </Button>
      )
    return <div />
  }

  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }
  return [
    <CommonScreen
      beforeRetrieveValidation={beforeRetrieveValidation}
      retrieveLabel="Retrieve Remote Data"
      extraCriteria={extraCriteria}
      screenCriteria={screenCriteria}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      title={title}
      header={headers}
      retrieveTask={kindleMySqlGetDALmp}
      withCriteria={withCriteria}
      sortOptions={headers}
      initialSortOptions={headers}
      widthOffset={600}
      insertComp={false}
      insertCompHeight={90}
      // onInsertEvent={b => setInsertEvent(b)}
      heightOffset={270}
      allowInsert={false}
      isAdminScreen={false}
      withoutModify
      withDelete={false}
      isEditableGrid={_ => false}
      totalWidth={800}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  pnodeZoneList: getPnodeZoneEffective(state),
})

export default connect(mapStateToProps)(KindleLmpDa)
